export const INTERVAL_MS = {
	"1m": 1 * 60 * 1000,
	"2m": 2 * 60 * 1000,
	"5m": 5 * 60 * 1000,
	"10m": 10 * 60 * 1000,
	"15m": 15 * 60 * 1000,
	"30m": 30 * 60 * 1000,
	"1h": 1 * 60 * 60 * 1000,
	"2h": 2 * 60 * 60 * 1000,
	"4h": 4 * 60 * 60 * 1000,
	"12h": 12 * 60 * 60 * 1000,
	"1d": 24 * 60 * 60 * 1000,
} as const;

export type Interval = keyof typeof INTERVAL_MS;

export function msTillNextTick(interval: Interval) {
	const now = Date.now();
	const ms = INTERVAL_MS[interval];
	return ms - (now % ms);
}
